import { Form, Checkbox, Space, Row, Col, Button, Pagination, Modal, Input, List } from "antd";
import React, { useEffect, useState } from "react";
import { SearchOutlined } from '@ant-design/icons';

const Seriales = ({ 
  productoselect, 
  seriales, 
  agregarserial,
  arrayproductosfacturar, // Add this prop
  onFetchSeriales,
  current,
  totalpagina,
  setPagination
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [loading, setLoading] = useState(false);

  const showModal = async () => {
    setLoading(true);
    try {
      // Fetch serials when opening modal
      await onFetchSeriales();
      setIsModalVisible(true);
    } catch (error) {
      console.error('Error fetching seriales:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setSearchText('');
  };

  const filteredSeriales = seriales.filter(serial =>
    serial.serial.toLowerCase().includes(searchText.toLowerCase())
  );

  const isSerialSelected = (serialId) => {
    return arrayproductosfacturar.some(item => 
      item.seriales.some(s => s.id === serialId)
    );
  };

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <Button 
        type="primary" 
        onClick={showModal}
        loading={loading}
      >
        Ver Seriales
      </Button>
      
      <Modal
        title="Seriales Disponibles"
        open={isModalVisible}
        onCancel={handleCancel}
        width={800}
        footer={null}
      >
        <Input
          placeholder="Buscar serial"
          prefix={<SearchOutlined />}
          onChange={e => setSearchText(e.target.value)}
          style={{ marginBottom: 16 }}
          allowClear
        />

        <List
          dataSource={filteredSeriales}
          renderItem={(item) => (
            <List.Item>
              <Checkbox 
                onChange={(e) => agregarserial(item.id, e.target.checked)}
                defaultChecked={isSerialSelected(item.id)}
              >
                {item.serial}
              </Checkbox>
            </List.Item>
          )}
        />

        <Pagination
          onChange={(page) => {
            setPagination(prev => ({ ...prev, current: page }));
          }}
          current={current}
          total={totalpagina}
          pageSize={20}
          style={{ marginTop: 16, textAlign: 'right' }}
        />
      </Modal>
    </Space>
  );
};

export default Seriales;
